import React, { useRef, useEffect } from "react";
import {
  useTranslate,
  FormTab,
  FormDataConsumer,
  Identifier,
  Record,
} from "react-admin";
import {
  Typography,
  Table,
  TableHead,
  TableRow,
  TableCell,
  Checkbox,
  TableBody,
} from "@material-ui/core";
import { useForm } from "react-final-form";
import "./SubscriptionFormEldsTab.css";

interface SubscriptionFormEldsTabProps {
  record?: Record;
}

const unassignedElds = [...Array(10)].map((_, i) => ({
  id: i + 1,
  vendor: "Geometris",
  serialNumber: "SN87A" + `${i + 1}`.padStart(6, "0"),
}));

export const SubscriptionFormEldsTab = (
  props: SubscriptionFormEldsTabProps
) => {
  const translate = useTranslate();
  const selectedElds = useRef<Identifier[]>([]);
  const form = useForm();
  form.registerField("rentedEldIds", () => {}, { value: true });

  useEffect(() => {
    if (props.record?.rentedEldIds) {
      selectedElds.current = props.record.rentedEldIds;
    }
  }, [props.record]);

  return (
    <FormTab label="resources.master-subscriptions.labels.elds" {...props}>
      <FormDataConsumer>
        {(_) => (
          <Typography id="elds-title">
            {translate("resources.master-subscriptions.labels.selectElds")}
          </Typography>
        )}
      </FormDataConsumer>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell padding="checkbox">
              <Checkbox />
            </TableCell>
            <TableCell>Serial number</TableCell>
            <TableCell>Vendor</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {unassignedElds.map((eld) => (
            <TableRow key={eld.id}>
              <TableCell padding="checkbox">
                <Checkbox
                  checked={props.record?.renderEldIds?.some(
                    (x: number) => x === eld.id
                  )}
                  onChange={(_, checked) => {
                    if (checked) {
                      selectedElds.current = [...selectedElds.current, eld.id];
                    } else {
                      selectedElds.current = [
                        ...selectedElds.current.filter((x) => x !== eld.id),
                      ];
                    }

                    form.change("rentedEldIds", selectedElds.current);
                  }}
                />
              </TableCell>
              <TableCell>{eld.serialNumber}</TableCell>
              <TableCell>{eld.vendor}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </FormTab>
  );
};
